import { z } from 'zod';

export const sourceSystemMap: Record<SourceSystem, SourceSystem> = {
  Manual: 'Manual',
  Ednition: 'Ednition',
  MyScholastic: 'MyScholastic',
  ScholasticOkta: 'ScholasticOkta',
  GoogleClassroom: 'GoogleClassroom',
  CMDM: 'CMDM',
  siteAuth: 'siteAuth',
} as const;
export const sourceSystemShape = z.union([
  z.literal('Ednition'),
  z.literal('MyScholastic'),
  z.literal('GoogleClassroom'),
  z.literal('ScholasticOkta'),
  z.literal('Manual'),
  z.literal('CMDM'),
  z.literal('siteAuth'),
]);
export type SourceSystem = z.infer<typeof sourceSystemShape>;

export const userRoleMap: Record<UserRole, UserRole> = {
  administrator: 'administrator',
  aide: 'aide',
  author: 'author',
  csr: 'csr',
  educator: 'educator',
  site_auth: 'site_auth',
  site_auth_admin: 'site_auth_admin',
  student: 'student',
  teacher: 'teacher',
  classPassword: 'classPassword',
} as const;
export const userRoleShape = z.union([
  z.literal('administrator'),
  z.literal('aide'),
  z.literal('author'),
  z.literal('csr'),
  z.literal('educator'),
  z.literal('site_auth'),
  z.literal('site_auth_admin'),
  z.literal('student'),
  z.literal('teacher'),
  z.literal('classPassword'),
]);
export type UserRole = z.infer<typeof userRoleShape>;

export const orgRoleShape = z.object({
  organization_id: z.string(),
  user_role: userRoleShape,
  is_primary: z.boolean().optional(),
});
export type OrgRole = z.infer<typeof orgRoleShape>;

export const productShape = z.object({
  id: z.string(),
  productCode: z.string(),
  productName: z.string(),
  thumbnailUrl: z.string(),
  applicationCode: z.string(),
  applicationLabel: z.string(),
  parentApplication: z.string().optional(),
  gradeLow: z.string().optional(),
  gradeHigh: z.string().optional(),
  description: z.string().optional(),
  subtitle: z.string().optional(),
  accessType: z.string().optional(),
  groupCode: z.string().optional(),
});
export type Product = z.infer<typeof productShape>;

export const userShape = z.object({
  id: z.string(),
  email: z.string().optional(),
  given_name: z.string(),
  middle_name: z.string().optional(),
  family_name: z.string(),
  type: z.string(),
  dob: z.string().optional(),
  username: z.string().optional(),
  password: z.string().optional(),
  grade: z.string().optional(),
  source_system_identifiers: z.array(
    z.object({
      source_system: sourceSystemShape,
      source_id: z.string(),
    })
  ),
  org_roles: z.array(orgRoleShape),
});
export type User = z.infer<typeof userShape>;

export const classResponseSchema = z.array(
  z.object({
    class_id: z.string(),
    grade_low: z.string().optional(),
    grade_high: z.string().optional(),
    name: z.string(),
    type: z.string(),
    organizationIds: z.array(z.string()),
    teachers: z.array(
      z.object({
        user_id: z.string(),
        given_name: z.string(),
        family_name: z.string(),
      })
    ),
    studentIds: z.array(z.string()),
    primary_teacher_id: z.string().optional(),
    source_id: z.string().optional(),
    source_id_type: z
      .union([z.literal('UCN'), z.literal('SourceId')])
      .optional(),
    source_system: sourceSystemShape.optional(),
  })
);
export type Class = z.TypeOf<typeof classResponseSchema>[0];

export const autoEntitlementShape = z.array(
  z.object({
    contextId: z.string(),
    contextType: z.string(),
    entitlementId: z.string().optional(),
    id: z.string(),
    subscriptionId: z.string(),
  })
);
export type AutoEntitlement = z.TypeOf<typeof autoEntitlementShape>[0];
